import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

export const GAME_SHOW_REPORT_ROUTE = {
  name: 'gameshowreport/:gameShowRunId',
  route(classId: string, gameShowRunId: string): string[] {
    return [...TEACHER_ROUTE.ACTIVE_CLASS.route(classId), 'gameshowreport', gameShowRunId];
  }
};
